module.exports = __webpack_public_path__ + "img/sidebar-icon-client.854cb080.svg";